export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    start() {},
    stop() {}
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};